// ─────────────────────────────────────────────────────────────────────────────
// TopNodesTable.js — "Most Used Nodes", ranked server-side by active circuits.
//
// COLUMNS is the single source of truth for the header, the cells and the
// loading skeleton — adding a column is one entry, and the header order can't
// drift from the cell order. (Same rule as the Nodes page's NodesTable.)
// ─────────────────────────────────────────────────────────────────────────────
import panel from "./panel.module.css";
import styles from "./TopNodesTable.module.css";

const COLUMNS = [
  { key: "id",     head: "NODE",        cell: (n) => n.id,        className: () => styles.tdId },
  { key: "region", head: "REGION",      cell: (n) => n.region },
  { key: "trust",  head: "TRUST SCORE", cell: (n) => n.trust },
  { key: "users",  head: "USERS",       cell: (n) => n.users,        right: true },
  { key: "load",   head: "LOAD",        cell: (n) => `${n.load}%`,   right: true },
];

const SKELETON_ROWS = 4;

function SkeletonRow() {
  return (
    <tr className={styles.tr}>
      {COLUMNS.map((c) => (
        <td key={c.key} className={styles.td}><div className={styles.skeletonBar} /></td>
      ))}
    </tr>
  );
}

/** @param {{rows: object[] | null, loading: boolean}} props — rows null = loading */
export default function TopNodesTable({ rows, loading }) {
  const isLoading = rows === null || loading;

  return (
    <div className={panel.card}>
      <div className={panel.header}>Most Used Nodes</div>
      <table className={styles.table}>
        <thead>
          <tr>
            {COLUMNS.map((c) => (
              <th key={c.key} className={`${styles.th} ${c.right ? styles.thRight : ""}`}>{c.head}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading
            ? Array.from({ length: SKELETON_ROWS }, (_, i) => <SkeletonRow key={i} />)
            : rows.length === 0
              ? (
                <tr>
                  {/* Its own rule rather than `.td` + panel's `.empty`: both are
                      single-class selectors, so which one won would depend on
                      the order the bundler emitted the two CSS modules in. */}
                  <td colSpan={COLUMNS.length} className={styles.emptyCell}>No data</td>
                </tr>
              )
              : rows.map((n, i) => (
                <tr key={i} className={styles.tr}>
                  {COLUMNS.map((c) => (
                    <td
                      key={c.key}
                      className={c.className?.(n) ?? `${styles.td} ${c.right ? styles.tdRight : ""}`}
                    >
                      {c.cell(n)}
                    </td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
}
